import mitt from 'mitt'

// Create a new Vue instance and export it
const emitter = mitt()
export default emitter
